// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./frontend/js/Components/Tiles/DoubleTile/doubleTile.scss
// module id = 607
// module chunks = 0